<div class="product-discussion" #discussionTop>
  <div class="enter-discussion flex items-center gap-3">
    <div class="user-image">
      <div class="c-img-r h-14 w-14 overflow-hidden rounded-full">
        <img
          class="h-14 w-14"
          [src]="user && user.propic_path ? user.propic_path : userDefaultPhoto"
          (error)="userErrorImg()" />
      </div>
    </div>
    <div class="discussion-form form-group relative flex-1">
      <input
        type="text"
        class="form-control w-full rounded-sm border-b border-b-primary-md-dark p-2 shadow-none line-clamp-2"
        [(ngModel)]="newDiscussion"
        (keyup.enter)="sendProductDiscussion()"
        placeholder="Any questions for this product? Feel free to asking here" />
      <div class="send-discussion bg-white">
        <button
          class="send absolute right-0 top-0 ml-2 rounded-md bg-white py-2 px-3 text-primary-md-dark"
          (click)="sendProductDiscussion()">
          Send
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="totalDiscussion > 0">
    <div
      class="discussion-item my-4 flex gap-3"
      *ngFor="let discussion of discussions; let i = index"
      [id]="i">
      <div class="user-image">
        <div class="c-img-r">
          <img
            class="h-12 w-12 overflow-hidden rounded-full"
            [src]="
              discussion.user.propic_path
                ? discussion.user.propic_path
                : userDefaultPhoto
            "
            (error)="userErrorImg()" />
        </div>
      </div>
      <div class="discussion w-full">
        <div class="user-name">
          {{ discussion.user.name }}
          <span class="seller" *ngIf="discussion.is_merchant">Seller</span>
        </div>
        <div class="timestamp text-xs text-stone-600">
          {{ discussion.formattedTimeStamp }}
        </div>
        <div class="discussion-text my-1 text-primary-darkest">
          {{ discussion.discussion }}
        </div>
        <div class="action-reply my-1 flex items-center gap-x-3 text-xs">
          <div
            class="view-replies flex items-center gap-2 text-primary-md-dark"
            *ngIf="discussion.total_replies > 0">
            <a
              class="flex items-center gap-2"
              (click)="showReplies(discussion, i)">
              <fa-icon
                class=""
                [icon]="discussion.showReplies ? faSortUp : faSortDown"
                [ngClass]="
                  discussion.showReplies ? 'up mt-1' : '-mt-1'
                "></fa-icon>
              <span *ngIf="discussion.showReplies">Minimize discussion</span>
              <span *ngIf="!discussion.showReplies"
                >See other {{ discussion.total_replies }} Replies</span
              >
            </a>
          </div>
          <div class="send-reply text-xs text-stone-600">
            <a (click)="discussion.showSendReply = !discussion.showSendReply"
              >Reply</a
            >
          </div>
        </div>
        <div
          class="enter-discussion relative mt-3 flex items-center justify-end gap-x-2"
          *ngIf="discussion.showSendReply">
          <div class="user-image">
            <div class="c-img-r">
              <img
                class="h-10 w-10 overflow-hidden rounded-full"
                [src]="user?.propic_path ? user?.propic_path : userDefaultPhoto"
                (error)="userErrorImg()" />
            </div>
          </div>
          <div class="discussion-form form-group my-2 flex-1 gap-3">
            <input
              type="text"
              class="form-control w-full rounded-sm border-b border-b-primary-md-dark p-2 shadow-none"
              [(ngModel)]="newReplies[i]"
              (keyup.enter)="sendDiscussionReply(discussion, i)"
              placeholder="Let us know what you think about this topic" />
          </div>
          <div class="send-discussion absolute right-2">
            <a
              class="send bg-white text-primary-md-dark"
              (click)="sendDiscussionReply(discussion, i)"
              >Reply</a
            >
          </div>
        </div>
        <div
          class="replies-list"
          *ngIf="discussion.showReplies && discussion.replyData">
          <div
            class="replies-item my-3 flex gap-3"
            *ngFor="
              let reply of discussion.replyData.product_discussion_replies
            ">
            <div class="user-image">
              <div class="c-img-r" *ngIf="reply.user">
                <img
                  class="h-12 w-12 overflow-hidden rounded-full"
                  [src]="
                    reply.user.propic_path
                      ? reply.user.propic_path
                      : userDefaultPhoto
                  "
                  (error)="userErrorImg()" />
              </div>
            </div>
            <div class="discussion">
              <div class="user-name">
                {{ reply.user.name }}
                <span class="seller" *ngIf="reply.is_merchant">Seller</span>
              </div>
              <div class="timestamp text-xs text-stone-600">
                {{ reply.formattedTimeStamp }}
              </div>
              <div class="discussion-text my-1 text-primary-darkest">
                {{ reply.discussion }}
              </div>
            </div>
          </div>
          <div *ngIf="loadedRepliesTotal[i] >= 10">
            <div
              class="show-more"
              *ngIf="loadedRepliesTotal[i] < discussion.replyData.total_items">
              <a (click)="showMoreReplies(discussion, i)">Expand</a>
            </div>
            <div
              class="show-less"
              *ngIf="loadedRepliesTotal[i] >= discussion.replyData.total_items">
              <a (click)="showLessReplies(discussion, i)">Minimize</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fc-pagination
      [totalItem]="totalDiscussion"
      [currentPage]="1"
      (pageChange)="pageChange($event)"></fc-pagination>
  </div>
  <div *ngIf="totalDiscussion < 1" class="empty-discussion text-center">
    <img
      src="assets/images/product/empty-discussion-illust.png"
      alt=""
      class="illust mx-auto mb-3 w-full max-w-[200px] py-3" />
    <div class="caption text-lg font-medium text-primary-darkest">
      Let us know what you think.
    </div>
    <div class="subcaption text-primary-md-dark">
      Any question? Discuss with sellers or users here now.
    </div>
  </div>
</div>
